/**
 * reCAPTCHA site keys are registered per domain, and each of our domains has
 * its own key. The old way to switch was to comment/uncomment a block in
 * `.env` before building (the same pattern `Config.js` uses for BASE_URL_*),
 * which tied a build to one domain — CRA inlines `process.env.REACT_APP_*` at
 * BUILD time, so the bundle carries a single baked value.
 *
 * Resolving from the hostname at runtime instead lets one build serve every
 * domain, with no `.env` edit before deploying.
 *
 * Site keys are PUBLIC — they ship in the rendered markup either way, and
 * Google rejects a key on any domain it is not registered for. The SECRET key
 * is server-side only (the `siteverify` call) and must never appear here.
 *
 * To add a domain, add a row. Matching is exact-host or subdomain, so
 * `www.quickvee.com` matches `quickvee.com` while `quickvee-qa.com` does not.
 */
const DOMAIN_SITE_KEYS = [
  { domain: 'quickvee.us', key: '6Lcn4XQtAAAAAPdXsmgVqFHOmGw9cw615qjGihn_' },
  { domain: 'quickvee.com', key: '6LenzzkrAAAAAMkx4vWttxHSdPyfjblBUsPSDvPJ' },
  {
    domain: 'quickvee-qa.com',
    key: '6LdT3XwsAAAAALYvkyIsBh7UW07XN_dJFJRowcRu',
  },
];

export const getRecaptchaSiteKey = () => {
  // Anything unlisted — localhost, previews, a new domain not added above —
  // falls back to the build-time key from .env, i.e. today's behaviour.
  const fallback = process.env.REACT_APP_CAPTCHAKEY || '';

  if (typeof window === 'undefined' || !window.location) {
    return fallback;
  }

  const host = String(window.location.hostname || '').toLowerCase();
  const match = DOMAIN_SITE_KEYS.find(
    ({ domain }) => host === domain || host.endsWith(`.${domain}`),
  );

  return (match && match.key) || fallback;
};
